"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * "FlixUtils" keeps general helpers (chrome, mobile, etc detection) and site variables (env, language, etc)
 */
var FlixUtils = function () {
  var FlixUtils = {};

  /**
   * Detect if it's mobile or not based on the screen width.
   * 
   * By default returns "true" for mobiles and tablets.
   * 
   * - `>=992` - web interface
   * - `480-992` - tablet or horizontal mobile
   * - `<480` - mobile (1 column of videos)
   * 
   * @param {integer} maxWidth
   * @returns {boolean}
   */
  FlixUtils.isMobile = function () {
    var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 992;
    return window.matchMedia("only screen and (max-width: " + maxWidth + "px)").matches;
  };
  FlixUtils.isMobileUA = function () {
    var toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i, /Opera Mini/i, /IEMobile/i, /WPDesktop/i];
    return toMatch.some(function (toMatchItem) {
      return navigator.Agent.match(toMatchItem);
    });
  };
  FlixUtils.renderBannerAd = function (zoneId, el, insClass, statsError) {
    var inMobile;
    inMobile = document.createElement('ins');
    inMobile.setAttribute('class', insClass);
    inMobile.setAttribute('data-zoneid', zoneId);
    inMobile.setAttribute('data-subid', Flix.ads.iid);
    inMobile.setAttribute('data-keywords', Flix.ads.tags);
    inMobile.setAttribute('data-ex_av', 0);

    /**
     * We display safe ads for s who are not verified
     */
    if (!Flix.ageVerified && Flix.requireAgeVerification) {
      inMobile.setAttribute('data-ex_av', 2);
      inMobile.setAttribute('data-block-ad-types', '101');
    } else {
      if (Flix.ageVerified && Flix.requireAgeVerification) {
        inMobile.setAttribute('data-ex_av', 1);
      }
    }
    var s = document.createElement('script');
    s.src = 'https://a.magsrv.com/ad-provider.js';
    s.type = 'text/javascript';
    s.async = true;
    s.setAttribute('data-cfasync', false);
    s.setAttribute('async', true);
    s.onerror = function () {
      return FlixStats.increment(statsError);
    };
    s.onload = function () {
      (window.AdProvider = window.AdProvider || []).push({
        "serve": {}
      });
    };
    el.appendChild(inMobile);
    el.appendChild(s);
  };
  /**
   * Desktop devices with width >= 992
   * @returns {boolean}
   */
  FlixUtils.isDesktop = function () {
    return !FlixUtils.isMobile();
  };

  /**
   * Detect Chrome browser
   * 
   * @returns {boolean}
   */
  FlixUtils.isChrome = function () {
    var isChromium = window.chrome,
      winNav = window.navigator,
      vendorName = winNav.vendor,
      isOpera = winNav.Agent.indexOf("OPR") > -1,
      isIEedge = winNav.Agent.indexOf("Edge") > -1,
      isIEedge2 = winNav.Agent.indexOf("Edg") > -1,
      isIOSChrome = winNav.Agent.match("CriOS");
    if (isIEedge2) {
      return false;
    }
    if (isIOSChrome) {
      return true;
    } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * Check if it's a bot or search engine crawler
   * @returns {boolean}
   */
  FlixUtils.isCrawler = function () {
    return /bot|crawl|spider|google|yahoo|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.Agent);
  };

  /**
   * Return `null` if cookie does not exists
   * @param {string} name 
   * @returns string|null
   */
  FlixUtils.getCookie = function (name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : null;
  };
  FlixUtils.setCookie = function (c_name, value, exdays) {
    var exdate = new Date();
    if (exdays != 0) {
      // ALLOW to handle part of day as 1/4, etc
      exdate.setTime(exdate.getTime() + exdays * 24 * 60 * 60 * 1000);
    }
    // get host without subdomain
    var domain = window.location.hostname.split('.').slice(-2).('.');
    var c_value = escape(value) + (exdays == null ? "" : "; expires=" + (exdays == 0 ? 0 : exdate.toUTCString())) + "; domain=." + domain + "; path=/";
    document.cookie = c_name + "=" + c_value;
  };

  /**
   * @param {string} name 
   * @returns {boolean}
   */
  FlixUtils.hasCookie = function (name) {
    return !!FlixUtils.getCookie(name);
  };

  /**
   * @param {string} name 
   */
  FlixUtils.deleteCookie = function (name) {
    FlixUtils.setCookie(name, '', {
      'max-age': -1
    });
  };

  /**
   * @returns {boolean}
   */
  FlixUtils.isLocalEnv = function () {
    return Flix.env == 'local';
  };

  /**
   * @returns {boolean}
   */
  FlixUtils.isIOS = function () {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) != -1
    // iPad on iOS 13 detection
    || navigator.Agent.indexOf("Mac") != -1 && "ontouchend" in document;
  };

  /**
   * Options for `FlixUtils.request()`
   * @see {FlixUtils.request}
   */
  var defaultRequestOptions = {
    /**
     * @param {string} method "GET", "POST", etc
     */
    method: 'GET',
    /**
     * @param {string} responseType "document", "json"
     */
    responseType: '',
    /**
     * @param {number} timeout in ms
     */
    timeout: 10000,
    /**
     * @param {(FormData|string|Document|Blob)} data will be used in `xhr.send(data)`
     */
    data: null,
    /**
     * By default xhr.response returned, but you can set it to "true" and 
     * get original xhr. XHR object has "parsedResponse" attribute that contain
     * default response or JSON if "autoParseJson" is true and json returned
     */
    returnXHR: false,
    /**
     * If response "content-type" header is "application/json" then we'll try to parse
     * response and return JSON object is possible.
     */
    autoParseJson: true,
    /**
     * Callback if you want to change `xhr` before sending request
     * @param {XMLHttpRequest} xhr 
     * @param {callback} resolve 
     * @param {callback} reject 
     */
    cb: function cb(xhr, resolve, reject) {}
  };

  /**
   * jQuery $.get, $.post and $.ajax replacement with default timeout 10 sec
   * Usage:
   * 
   * ```js
   * // Basic GET example
   * FlixUtils.request('https://site.com')
   *      .then(html => {})
   *      .catch(err => {})
   *      .finally(() => {});
   * 
   * // POST request
   * var formData = new FormData();
   * formData.append('key', 'val');
   * 
   * FlixUtils.request('https://site.com', { method: "POST", data: formData })
   *      .then(html => {})
   * 
   * // Modify `xhr` before sending request
   * FlixUtils.request('https://site.com', { cb: xhr => xhr.setRequestHeader('key', 'val') })
   *      .then(html => {})
   * 
   * // Small hint how to get Document instance in response instead of HTML
   * FlixUtils.request('https://site.com', { responseType: 'document' })
   *      .then(doc => doc.querySelector('#some-id'))
   * 
   * // Same hind but to auto parse JSON and with `cb` example
   * FlixUtils.request('https://site.com', { cb: xhr => xhr.responseType = 'json' })
   *      .then(json => {})
   * ```
   * 
   * @param {string} url 
   * @param {defaultRequestOptions} options 
   * @param {bool} withCredentials
   * @returns {Promise}
   */
  FlixUtils.request = function (url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultRequestOptions;
    var withCredentials = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    options = _objectSpread(_objectSpread({}, defaultRequestOptions), options);
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method, url);
      if (withCredentials) {
        xhr.withCredentials = true;
      }
      // Mark as ajax request if send to the same domain
      if (url.charAt(0) == '/' || url.substring(0, 40).toLocaleLowerCase().indexOf(window.location.host) != -1) {
        xhr.setRequestHeader('X-Requested-With', 'xmlhttprequest');
      }
      xhr.responseType = options.responseType;
      xhr.timeout = options.timeout;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          xhr.parsedResponse = xhr.response;
          if (xhr.getResponseHeader('content-type') == 'application/json' && options.autoParseJson && typeof xhr.response == 'string') {
            try {
              xhr.parsedResponse = JSON.parse(xhr.response);
            } catch (er) {}
          }
          resolve(options.returnXHR ? xhr : xhr.parsedResponse);
        } else {
          reject("".concat(xhr.status, " - ").concat(xhr.statusText));
        }
      };
      xhr.onabort = function () {
        return reject('Request aborted');
      };
      xhr.ontimeout = function () {
        return reject("Timeout after ".concat(xhr.timeout, " ms"));
      };
      xhr.onerror = function () {
        return reject("".concat(xhr.status, " - ").concat(xhr.statusText));
      };
      new Promise(function (res) {
        return res(options.cb(xhr, resolve, reject));
      }).then(function () {
        return xhr.send(options.data);
      });
    });
  };
  FlixUtils.initAge = function () {
    var style = document.createElement('style');
    style.innerHTML = '#agego-overlay-container {display:flex!important}';
    document.head.appendChild(style);
    if (document.querySelector('#agego-overlay-container')) {
      var _document$querySelect;
      document.querySelector('#agego-overlay-container').append(style);
      document.querySelector('#agego-overlay-container').style.display = 'flex!important';
      (_document$querySelect = document.querySelector('#agego-blur-stylev2')) === null || _document$querySelect === void 0 || _document$querySelect.remove();
    }
    document.body.classList.add('agego-blur-content');
  };

  /**
   * Ids used to  "fatigue" and "_behavior" records of the same session
   */
  FlixUtils.stats = function () {
    var stats = {};
    var IDLE_HOURS = 6;
    var mintId = function mintId() {
      return String(Date.now()) + ('000000' + Math.floor(Math.random() * 1e6)).slice(-6);
    };

    /**
     * @param {string} type "localStorage" or "sessionStorage"
     * @param {string} key
     * @returns {string|null}
     */
    var get = function get(type, key) {
      try {
        return window[type].getItem(key);
      } catch (e) {
        return null;
      }
    };

    /**
     * @param {string} type "localStorage" or "sessionStorage"
     * @param {string} key
     * @param {string} value
     * @returns {boolean} "false" when the browser blocks web storage
     */
    var set = function set(type, key, value) {
      try {
        window[type].setItem(key, value);
        return true;
      } catch (e) {
        return false;
      }
    };

    /**
     * Visit id shared by all tabs. New id after 6 hours without activity.
     * Reading it counts as activity.
     *
     * @returns {string} "0" when the id cannot be persisted
     */
    stats.getCrossId = function () {
      var now = Date.now();
      var last = parseInt(get('localStorage', 'flix_stats_cross_last'), 10) || 0;
      var id = get('localStorage', 'flix_stats_cross_id');
      if (!id || now - last > IDLE_HOURS * 60 * 60 * 1000) {
        id = mintId();
      }
      if (!set('localStorage', 'flix_stats_cross_id', id)) {
        return '0';
      }
      set('localStorage', 'flix_stats_cross_last', String(now));
      return id;
    };

    /**
     * Id of the current tab. Replaced when the visit id changes.
     *
     * @returns {string} "0" when the id cannot be persisted
     */
    stats.getTabId = function () {
      var crossId = stats.getCrossId();
      var id = get('sessionStorage', 'flix_tab_id');
      if (!id || get('sessionStorage', 'flix_tab_cross') !== crossId) {
        id = mintId();
      }
      if (!set('sessionStorage', 'flix_tab_id', id)) {
        return '0';
      }
      set('sessionStorage', 'flix_tab_cross', crossId);
      return id;
    };
    return stats;
  }();
  return FlixUtils;
}();